const formCategories = [
  {
    formCategory: 'graffiti_posters_and_stickers',
    inferCategories: [
      'Posters and Stickers',
      'Posters',
      'Stickers',
      'Posters or Stickers',
      'Graffiti',
    ],
  },
  {
    formCategory: 'dumped_rubbish',
    inferCategories: [
      'Household Appliances',
      'Construction and DIY',
      'Furniture',
      'Other Dumped Rubbish',
    ],
  },
  {
    formCategory: 'bin_bags',
    inferCategories: ['Bin Bags'],
  },
  {
    formCategory: 'cardboard_boxes',
    inferCategories: ['Cardboard'],
  },
  {
    formCategory: 'litter',
    inferCategories: ['Litter'],
  },
  {
    formCategory: 'bins',
    inferCategories: ['Bins'],
  },
  {
    formCategory: 'street_cleaning',
    inferCategories: ['Street cleaning'],
  },
];

export const getInferImageCategory = (item: string | undefined) => {
  let result = undefined;
  formCategories.map((category) => {
    if (item === undefined) {
      return '';
    } else if (category.inferCategories?.includes(item)) {
      result = category.formCategory;
    }
  });
  return result;
};
